export default __webpack_public_path__ + "static/media/eye-dark.a3f2e8a2.svg";